module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-page"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('section', [_vm._m(0), _c('h1', [_vm._v(_vm._s(_vm.$route.meta.title))]), _vm._m(1)]), _c('section', [_c('div', {
    staticClass: "tab-wrap"
  }, _vm._l((_vm.tabs), function(tab, index) {
    return _c('div', {
      staticClass: "tab-item",
      class: {
        actived: _vm.nowTab === index
      },
      on: {
        "click": function($event) {
          _vm.tabSelect(index)
        }
      }
    }, [_vm._v(_vm._s(tab.name))])
  }))]), _c('div', {
    staticClass: "mb-10"
  }), (_vm.nowTab === 0) ? _c('section', [_c('div', {
    staticClass: "section-title"
  }, [_vm._v("2015")]), _c('div', {
    staticClass: "mb-4"
  }, _vm._l((_vm.news.y2015), function(post) {
    return _c('div', {
      staticClass: "news-wrap"
    }, [_c('a', {
      staticClass: "news-item",
      attrs: {
        "href": post.link,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "left"
    }, [_c('img', {
      attrs: {
        "src": require("assets/logo-frame.svg")
      }
    }), _c('div', {
      staticClass: "time"
    }, [_vm._v(_vm._s(post.time))])]), _c('div', {
      staticClass: "right"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(post.title))]), _c('div', {
      staticClass: "description"
    }, [_vm._v(_vm._s(post.publisher))])])])])
  }))]) : _vm._e(), (_vm.nowTab === 1) ? _c('section', [_c('div', {
    staticClass: "section-title"
  }, [_vm._v("2016")]), _c('div', {
    staticClass: "mb-4"
  }, _vm._l((_vm.news.y2016), function(post) {
    return _c('div', {
      staticClass: "news-wrap"
    }, [_c('a', {
      staticClass: "news-item",
      attrs: {
        "href": post.link,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "left"
    }, [_c('img', {
      attrs: {
        "src": require("assets/logo-frame.svg")
      }
    }), _c('div', {
      staticClass: "time"
    }, [_vm._v(_vm._s(post.time))])]), _c('div', {
      staticClass: "right"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(post.title))]), _c('div', {
      staticClass: "description"
    }, [_vm._v(_vm._s(post.publisher))])])])])
  }))]) : _vm._e(), (_vm.nowTab === 2) ? _c('section', [_c('div', {
    staticClass: "section-title"
  }, [_vm._v("4Gamers 站內新聞")]), _c('div', {
    staticClass: "mb-4"
  }, [_vm._l((_vm.getNews.data), function(post) {
    return _c('div', {
      staticClass: "news-wrap"
    }, [_c('a', {
      staticClass: "news-item",
      attrs: {
        "href": 'https://www.4gamers.com.tw/news/detail/' + post.news_id + '/' + post.url_string,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "left"
    }, [_c('img', {
      attrs: {
        "src": require("assets/logo-frame.svg")
      }
    }), (!_vm.newsLoading) ? _c('div', {
      staticClass: "time"
    }, [_vm._v(_vm._s(_vm._f("moment-news")(post.created_at)))]) : _c('div', {
      staticClass: "time"
    }, [_c('div', {
      staticClass: "spinner"
    }, [_c('div', {
      staticClass: "bounce bounce1"
    }), _c('div', {
      staticClass: "bounce bounce2"
    }), _c('div', {
      staticClass: "bounce bounce3"
    })])])]), _c('div', {
      staticClass: "right"
    }, [(!_vm.newsLoading) ? _c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(post.title))]) : _c('div', {
      staticClass: "title"
    }, [_c('div', {
      staticClass: "spinner"
    }, [_c('div', {
      staticClass: "bounce bounce1"
    }), _c('div', {
      staticClass: "bounce bounce2"
    }), _c('div', {
      staticClass: "bounce bounce3"
    })])]), _c('div', {
      staticClass: "description"
    }, [_vm._v("4Gamers")])])])])
  }), (_vm.getNews.meta) ? _c('div', {
    staticClass: "pagination"
  }, [_c('div', {
    staticClass: "btn ghost-btn",
    attrs: {
      "disabled": _vm.newsPage === 1
    },
    on: {
      "click": _vm.prePage
    }
  }, [_vm._v("上一頁")]), _c('div', {
    staticClass: "currentPage"
  }, [_c('span', {
    staticClass: "now"
  }, [_vm._v(_vm._s(_vm.getNews.meta._paginator.current_page))]), _c('span', {
    staticClass: "last"
  }, [_vm._v("/ " + _vm._s(_vm.getNews.meta._paginator.last_page))])]), _c('div', {
    staticClass: "btn ghost-btn",
    attrs: {
      "disabled": _vm.newsPage === _vm.getNews.meta._paginator.last_page
    },
    on: {
      "click": _vm.nextPage
    }
  }, [_vm._v("下一頁")])]) : _vm._e()], 2)]) : _vm._e(), _c('div', {
    staticClass: "mb-40"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-decoration"
  }, [_c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "dot"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-center",
    staticStyle: {
      "margin-bottom": "32px"
    }
  }, [_vm._v("WirForce 2015 以爆發性五倍成長再創顛峰，BYOC 參與數達 400 人，集結 12 家國內外知名廠商，總來場人數超過 2 萬人次，全程活動實況締造超過 75 萬不重複觀看人次，總曝光觸及人數超過 2,000 萬！"), _c('br'), _c('br'), _vm._v("WirForce 2016 BYOC 參與數達 600 人，總來場人數超過 7 萬人次，全程活動實況締造超過 100 萬以上不重複觀看人次，總曝光觸及人數超過 3,000 萬！!")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08254f6f"}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/news.vue
// module id = 558
// module chunks = 1